import { useMutation } from "@tanstack/react-query";
import { useRouter } from "next/navigation";

import { completeOnboarding, CompleteOnboardingRequest, uploadImage, UploadImageRequest } from "@/api";
import { useUIStore } from "stores/ui.store";

const useCompleteOnboarding = () => {
  const { replace } = useRouter();

  const openToast = useUIStore((state) => state.actions.toast.openToast);
  // const referralCode = useOnboardingStore((state) => state.referralCode);

  return useMutation({
    mutationFn: async ({
      userDetailedInfo,
      profileImageFormData,
    }: {
      userDetailedInfo: CompleteOnboardingRequest;
      profileImageFormData: UploadImageRequest;
    }) => {
      const profileImageFile = new FormData();
      profileImageFile.append("file", profileImageFormData.get("profileImage") as File);

      const profileImageSource = await uploadImage(profileImageFile);

      return completeOnboarding({
        ...userDetailedInfo,
        profileImage: profileImageSource,
      });
    },
    onSuccess: () => {
      replace("/auth/onboarding/completed");
    },
    onError: (error) => {
      const customError = error as any;

      openToast({ message: customError.response.data.message, variant: "error" });
    },
  });
};

export { useCompleteOnboarding };
